import { FillsGraphActionPayload } from './actions';
import { fillsGraphConfigReducer } from './configuration/reducer';
import { fillsGraphDataReducer } from './data/reducer';
import { FillsGraphWidgetState } from './FillsGraphWidgetState';
import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { buildFillsGraphComponentSlice } from 'widgets/fillsGraph/store/component/componentSlice';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const { reducer: componentReducer } = buildFillsGraphComponentSlice();

const widgetStateReducer = combineReducers<FillsGraphWidgetState>({
    stream: fillsGraphDataReducer,
    config: fillsGraphConfigReducer,
    component: componentReducer,
});

export const fillsGraphWidgetsReducer = createWidgetsReducer<
    FillsGraphWidgetState,
    FillsGraphActionPayload
>(WidgetType.FILLS_GRAPH, widgetStateReducer);
